import { Tab as BaseTab, TabProps, forwardRef } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import { mq } from 'styles/breakpoints';
import { rem } from 'utils/fonts';

const StyledTab = styled(BaseTab)`
  padding: 13px 20px;

  ${mq.md} {
    padding: 13px 35px;
  }
`;

// eslint-disable-next-line react/display-name
const Tab = forwardRef<TabProps, 'button'>(({ children, ...props }, ref) => (
  <StyledTab ref={ref} color="gray.400" fontSize={rem(17)} _selected={{ color: 'gray.900', borderColor: 'pink.500' }} {...props}>
    {children}
  </StyledTab>
));

export default Tab;
